export const TokenName = '';
export const LoginPath = '/JYQUs6iBoxZmm/login';
